// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.generic-preset-picker {
  width: calc(max(94vw, 600px));
  height: calc(max(100vh - 150px, 450px));
  display: flex;
  flex-direction: row;

  .generic-preset-picker-search-bar {
    box-sizing: border-box;
    display: flex;
    height: 28px;
    width: calc(100% - 10px);
    padding: 4px 8px;
    margin-bottom: 10px;
  }

  .select-preset-prompt {
    text-align: center;
    font-size: 22px;
    margin-top: 12px;
  }

  .preset-info-wrapper {
    background-color: #121212;
    flex: 1;
    margin-bottom: -2px;
    display: flex;
    flex-direction: column;

    .preset-info {
      display: flex;
      flex-direction: column;
      padding: 10px;
      overflow-y: auto;
      overflow-x: hidden;
      margin-bottom: 20px;

      .preset-info-item {
        display: grid;
        grid-template-columns: 100px 1fr;
        margin-top: 2px;
        margin-bottom: 6px;
        white-space: pre;

        > div:first-child {
          font-weight: bold;
        }
      }
    }

    .buttons-container {
      justify-content: center;
      margin-bottom: 24px;

      > button {
        width: 110px;
        height: 30px;
      }
    }
  }
}

.preset-list {
  border: 1px solid #484848;
  margin-top: auto;
  margin-bottom: auto;
  margin-right: 14px;

  .generic-preset-picker-row {
    display: flex;
    flex-direction: row;
    box-sizing: border-box;
    line-height: 18px;
    overflow: hidden;
    padding: 2px 4px;
    cursor: pointer;
    border-bottom: 1px solid #5d5d5d;

    &[data-selected='true'] {
      background-color: #04d6cf66;
      color: #fff;
    }

    &:hover {
      background-color: #646464aa;
    }

    .svg-wrapper {
      width: 14px;
      height: 14px;
      padding-right: 4px;
      filter: opacity(0.78);
    }

    .preset-name {
      flex: 1;
      min-width: 0;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
    }
  }
}

.generic-preset-saver {
  display: flex;
  flex-direction: column;
  width: calc(max(63vw, 600px));
  height: calc(max(75vh, 450px));
  min-height: 500px;

  .generic-preset-saver-form {
    display: flex;
    flex-direction: column;
    margin-top: 12px;

    > div {
      display: flex;
      flex-direction: row;
      display: grid;
      width: 600px;
      grid-template-columns: 100px 500px;
      margin-bottom: 8px;

      input[type='text'] {
        width: 200px;
      }

      textarea {
        height: 130px;
      }
    }
  }

  .tag-picker {
    display: flex;
    flex-direction: column;
    margin-top: 12px;
    margin-bottom: 12px;

    h3 {
      margin-top: 12px;
      margin-bottom: 6px;
    }
  }

  .control-panel {
    background-color: #131313 !important;
    margin-top: 14px;
  }

  .buttons-container {
    justify-content: flex-start;
    margin-top: 10px;
    margin-left: -7px;

    > button {
      width: 110px;
      height: 30px;
    }
  }
}

.tags-container {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  min-height: 26px;
}

.tag-picker-tag {
  cursor: pointer;
  display: flex;
  min-width: 50px;
  justify-content: center;
  margin-right: 8px;
  padding: 3px 8px 4px 8px;
  line-height: 14px;
  border: 1px solid #ccc;
  border-radius: 9px;
  user-select: none;

  &[data-selected='false']:hover {
    background-color: rgb(141, 69, 129);
  }

  &[data-selected='true'] {
    background-color: rgb(182, 59, 161);
    color: #fff;
  }
}
`, "",{"version":3,"sources":["webpack://./src/controls/GenericPresetPicker/GenericPresetPicker.css"],"names":[],"mappings":"AAAA;EACE,6BAA6B;EAC7B,uCAAuC;EACvC,aAAa;EACb,mBAAmB;;EAEnB;IACE,sBAAsB;IACtB,aAAa;IACb,YAAY;IACZ,wBAAwB;IACxB,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,yBAAyB;IACzB,OAAO;IACP,mBAAmB;IACnB,aAAa;IACb,sBAAsB;;IAEtB;MACE,aAAa;MACb,sBAAsB;MACtB,aAAa;MACb,gBAAgB;MAChB,kBAAkB;MAClB,mBAAmB;;MAEnB;QACE,aAAa;QACb,gCAAgC;QAChC,eAAe;QACf,kBAAkB;QAClB,gBAAgB;;QAEhB;UACE,iBAAiB;QACnB;MACF;IACF;;IAEA;MACE,uBAAuB;MACvB,mBAAmB;;MAEnB;QACE,YAAY;QACZ,YAAY;MACd;IACF;EACF;AACF;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;;EAElB;IACE,aAAa;IACb,mBAAmB;IACnB,sBAAsB;IACtB,iBAAiB;IACjB,gBAAgB;IAChB,gBAAgB;IAChB,eAAe;IACf,gCAAgC;;IAEhC;MACE,2BAA2B;MAC3B,WAAW;IACb;;IAEA;MACE,2BAA2B;IAC7B;;IAEA;MACE,WAAW;MACX,YAAY;MACZ,kBAAkB;MAClB,qBAAqB;IACvB;;IAEA;MACE,OAAO;MACP,YAAY;MACZ,mBAAmB;MACnB,uBAAuB;MACvB,gBAAgB;IAClB;EACF;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,6BAA6B;EAC7B,8BAA8B;EAC9B,iBAAiB;;EAEjB;IACE,aAAa;IACb,sBAAsB;IACtB,gBAAgB;;IAEhB;MACE,aAAa;MACb,mBAAmB;MACnB,aAAa;MACb,YAAY;MACZ,kCAAkC;MAClC,kBAAkB;;MAElB;QACE,YAAY;MACd;;MAEA;QACE,aAAa;MACf;IACF;EACF;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,gBAAgB;IAChB,mBAAmB;;IAEnB;MACE,gBAAgB;MAChB,kBAAkB;IACpB;EACF;;EAEA;IACE,oCAAoC;IACpC,gBAAgB;EAClB;;EAEA;IACE,2BAA2B;IAC3B,gBAAgB;IAChB,iBAAiB;;IAEjB;MACE,YAAY;MACZ,YAAY;IACd;EACF;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,iBAAiB;EACjB,wBAAwB;EACxB,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;;EAEjB;IACE,mCAAmC;EACrC;;EAEA;IACE,mCAAmC;IACnC,WAAW;EACb;AACF","sourcesContent":[".generic-preset-picker {\n  width: calc(max(94vw, 600px));\n  height: calc(max(100vh - 150px, 450px));\n  display: flex;\n  flex-direction: row;\n\n  .generic-preset-picker-search-bar {\n    box-sizing: border-box;\n    display: flex;\n    height: 28px;\n    width: calc(100% - 10px);\n    padding: 4px 8px;\n    margin-bottom: 10px;\n  }\n\n  .select-preset-prompt {\n    text-align: center;\n    font-size: 22px;\n    margin-top: 12px;\n  }\n\n  .preset-info-wrapper {\n    background-color: #121212;\n    flex: 1;\n    margin-bottom: -2px;\n    display: flex;\n    flex-direction: column;\n\n    .preset-info {\n      display: flex;\n      flex-direction: column;\n      padding: 10px;\n      overflow-y: auto;\n      overflow-x: hidden;\n      margin-bottom: 20px;\n\n      .preset-info-item {\n        display: grid;\n        grid-template-columns: 100px 1fr;\n        margin-top: 2px;\n        margin-bottom: 6px;\n        white-space: pre;\n\n        > div:first-child {\n          font-weight: bold;\n        }\n      }\n    }\n\n    .buttons-container {\n      justify-content: center;\n      margin-bottom: 24px;\n\n      > button {\n        width: 110px;\n        height: 30px;\n      }\n    }\n  }\n}\n\n.preset-list {\n  border: 1px solid #484848;\n  margin-top: auto;\n  margin-bottom: auto;\n  margin-right: 14px;\n\n  .generic-preset-picker-row {\n    display: flex;\n    flex-direction: row;\n    box-sizing: border-box;\n    line-height: 18px;\n    overflow: hidden;\n    padding: 2px 4px;\n    cursor: pointer;\n    border-bottom: 1px solid #5d5d5d;\n\n    &[data-selected='true'] {\n      background-color: #04d6cf66;\n      color: #fff;\n    }\n\n    &:hover {\n      background-color: #646464aa;\n    }\n\n    .svg-wrapper {\n      width: 14px;\n      height: 14px;\n      padding-right: 4px;\n      filter: opacity(0.78);\n    }\n\n    .preset-name {\n      flex: 1;\n      min-width: 0;\n      white-space: nowrap;\n      text-overflow: ellipsis;\n      overflow: hidden;\n    }\n  }\n}\n\n.generic-preset-saver {\n  display: flex;\n  flex-direction: column;\n  width: calc(max(63vw, 600px));\n  height: calc(max(75vh, 450px));\n  min-height: 500px;\n\n  .generic-preset-saver-form {\n    display: flex;\n    flex-direction: column;\n    margin-top: 12px;\n\n    > div {\n      display: flex;\n      flex-direction: row;\n      display: grid;\n      width: 600px;\n      grid-template-columns: 100px 500px;\n      margin-bottom: 8px;\n\n      input[type='text'] {\n        width: 200px;\n      }\n\n      textarea {\n        height: 130px;\n      }\n    }\n  }\n\n  .tag-picker {\n    display: flex;\n    flex-direction: column;\n    margin-top: 12px;\n    margin-bottom: 12px;\n\n    h3 {\n      margin-top: 12px;\n      margin-bottom: 6px;\n    }\n  }\n\n  .control-panel {\n    background-color: #131313 !important;\n    margin-top: 14px;\n  }\n\n  .buttons-container {\n    justify-content: flex-start;\n    margin-top: 10px;\n    margin-left: -7px;\n\n    > button {\n      width: 110px;\n      height: 30px;\n    }\n  }\n}\n\n.tags-container {\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  min-height: 26px;\n}\n\n.tag-picker-tag {\n  cursor: pointer;\n  display: flex;\n  min-width: 50px;\n  justify-content: center;\n  margin-right: 8px;\n  padding: 3px 8px 4px 8px;\n  line-height: 14px;\n  border: 1px solid #ccc;\n  border-radius: 9px;\n  user-select: none;\n\n  &[data-selected='false']:hover {\n    background-color: rgb(141, 69, 129);\n  }\n\n  &[data-selected='true'] {\n    background-color: rgb(182, 59, 161);\n    color: #fff;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
